import { render, staticRenderFns } from "./Ruminate.vue?vue&type=template&id=5f67487c&scoped=true"
import script from "./Ruminate.vue?vue&type=script&lang=js"
export * from "./Ruminate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f67487c",
  null
  
)

export default component.exports